var incidentDetails = (function () {

    //#region variables
    var SelectedIncidentId;
    var SelectedConsumer;
    var consumerId;
    var consumerInvolementId;
    var formReadOnly = false;
    var isErrorOccured = false;

    // Incident Details variables
    var categories;
    var incidentLocations;
    var incidentDetails;
    var involvementTypes;
    var employeeNames;
    var incidentDate;
    var incidentTime;
    var reportedDate;
    var reportedTime;
    var categoryId;
    var locationId;
    var summaryText;
    var actionText;
    var preventionText;
    var factorsText;
    var reviewData;
    var involvementLocations = [];

    // Individuals Involved data
    var individualsInvolvedData = [];
    var employeesInvolvedData = [];
    var otherPeopleInvolvedData = [];
    var allConsumersForDropdown = [];    

    // Inputs
    var incidentDateInput;
    var incidentTimeInput;
    var reportedDateInput;
    var reportedTimeInput;
    var summaryTextarea;
    var actionTextarea;
    var preventionTextarea;
    var causeTextarea;
    var categoryDropdown;
    var locationDetailDropdown;

    // Attachments  
    var attchmentsData = [];
    let attachmentsToDelete = [];

    // DOM elements
    var contentDiv;
    var incidentDetailsSection;
    var individualErrorIcon;

    // Tables
    var individualsTable;
    var employeesTable;
    var otherPeopleTable;
    var attchamentsTable;
    //#endregion
    var pageLoadPopup;
    var newIncident = false;

    //#region common functions
    function buildNavigation() {
        var navEle = document.createElement('div');
        var ulEle = document.createElement('ul');
        // Incident Details Link
        var liIncidentDetailsEle = document.createElement('li');
        liIncidentDetailsEle.style.marginBottom = '15px';
        var linkIncidentDetailsEle = document.createElement('a');
        linkIncidentDetailsEle.innerHTML = 'Incident Details <div class="error errorIcon hidden" id="errorIcon">' + icons['error'] + '</div>';
        linkIncidentDetailsEle.style.fontWeight = 'bold';
        linkIncidentDetailsEle.style.cursor = 'pointer';
        linkIncidentDetailsEle.classList.add('incident_details_link', 'active');
        liIncidentDetailsEle.appendChild(linkIncidentDetailsEle);
        ulEle.appendChild(liIncidentDetailsEle);

        // Individuals Involved Header
        var liIndividualsInvolvedTextEle = document.createElement('li');
        var pIndividualsInvolvedTextEle = document.createElement('p');
        pIndividualsInvolvedTextEle.textContent = 'Individuals Involved';
        pIndividualsInvolvedTextEle.style.fontWeight = 'bold';
        pIndividualsInvolvedTextEle.style.marginBottom = '10px';
        liIndividualsInvolvedTextEle.appendChild(pIndividualsInvolvedTextEle);
        liIndividualsInvolvedTextEle.style.marginBottom = '15px';
        ulEle.appendChild(liIndividualsInvolvedTextEle);
        var ulIndividualsEleContainer = document.createElement('ul');
        ulIndividualsEleContainer.classList.add('individuals_involved_list');
        ulEle.appendChild(ulIndividualsEleContainer);
        navEle.appendChild(ulEle);
        return navEle;
    }
    function updateIndividualNavMenuItems() {
        var individualNavItems = [];
        // Get consumers involved in incident - ONLY if SelectedIncidentId exists       
        if (individualsInvolvedData && individualsInvolvedData.length > 0) {
            individualsInvolvedData = individualsInvolvedData.sort((a, b) =>
                a.lastName.localeCompare(b.lastName, undefined, { sensitivity: "base" }));
            individualsInvolvedData.forEach(consumer => {
                var liIndividualEle = document.createElement('li');
                var linkIndividualEle = document.createElement('a');
                linkIndividualEle.textContent = `${consumer.lastName}, ${consumer.firstName} ${consumer.middleName||''}`;
                linkIndividualEle.style.cursor = 'pointer';
                linkIndividualEle.setAttribute('data-consumer-id', consumer.consumerId);
                linkIndividualEle.setAttribute('data-consumer-involvement-id', consumer.consumerInvolvedId);
                linkIndividualEle.classList.add('individual_nav');
                liIndividualEle.style.padding = '8px';
                liIndividualEle.appendChild(linkIndividualEle);
                individualNavItems.push(liIndividualEle);
            });
        }
        return individualNavItems;
    }
    function handleIndividualNavEvents(event) {
        var target = event.target;
        if (target.classList.contains('individual_nav')) {
            // Get consumer IDs
            consumerId = target.getAttribute('data-consumer-id');
            showProgressPopup('Please wait while we gather everything up...');
            saveIncidentDetails();
        }
    }
    //#endregion

    //#region Incident Details Section
    async function getSectionData() {       
        categories = incidentTracking.getCategories();
        incidentDetails = incidentTracking.getLocations();
    }

    async function setSectionValues() {
        if (reviewData && reviewData.itReviewData && reviewData.itReviewData.length > 0) {
            var rd = reviewData.itReviewData[0];
            incidentDate = rd.incidentDate ? UTIL.formatDateToIso(rd.incidentDate.split(' ')[0]) : '';
            incidentTime = rd.incidentTime ? rd.incidentTime : '';
            reportedDate = rd.reportedDate ? UTIL.formatDateToIso(rd.reportedDate.split(' ')[0]) : '';
            reportedTime = rd.reportedTime ? rd.reportedTime : '';
            categoryId = rd.subcategoryId ? rd.subcategoryId : '';
            locationId = rd.locationId ? rd.locationId : '';
            summaryText = rd.summary ? rd.summary : '';
            actionText = rd.note ? rd.note : '';
            preventionText = rd.prevention ? rd.prevention : '';
            factorsText = rd.contributingFactor ? rd.contributingFactor : '';
           
        } else {
            var defaultCategory = categories.filter(c => c.incidentCategory === 'New Incident');
            incidentDate = $.session.incidentTrackingPopulateIncidentDate === 'Y' ? UTIL.getTodaysDate()  : '';
            incidentTime = $.session.incidentTrackingPopulateIncidentTime === 'Y' ? UTIL.getCurrentTime() : '';
            reportedDate = $.session.incidentTrackingPopulateReportedDate === 'Y' ? UTIL.getTodaysDate()  : '';
            reportedTime = $.session.incidentTrackingPopulateReportedTime === 'Y' ? UTIL.getCurrentTime() : '';
            categoryId = defaultCategory[0] ? defaultCategory[0].subcategoryId : '';
            locationId = '';
            summaryText = '';
            actionText = '';
            preventionText = '';
            factorsText = '';
        }
    }

    function buildDateTimeInputs() {
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '20px';

        incidentDateInput = new Input({
            label: 'Incident Date*',
            id: 'incidentDateInpt',
            type: 'date',             
            attributes: [{ key: 'max', value: '9999-12-31' }],
            value: incidentDate,
            readonly: formReadOnly
        });

        incidentTimeInput = new Input({
            label: 'Incident Time',
            type: 'time',           
            value: incidentTime,
            readonly: formReadOnly
        });

        reportedDateInput = new Input({
            label: 'Reported Date',
            type: 'date',           
            attributes: [{ key: 'max', value: '9999-12-31' }],
            value: reportedDate,
            readonly: formReadOnly
        });

        reportedTimeInput = new Input({
            label: 'Reported Time',
            type: 'time',            
            value: reportedTime,
            readonly: formReadOnly
        });

        reportedDateInput.rootElement.style.marginTop = '-20px';
        reportedTimeInput.rootElement.style.marginTop = '-20px';
        container.appendChild(incidentDateInput.rootElement);
        container.appendChild(incidentTimeInput.rootElement);
        container.appendChild(reportedDateInput.rootElement);
        container.appendChild(reportedTimeInput.rootElement);

        return container;
    }

    function buildDropdowns() {
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '10px';
        // Get and set data
        var categoryData = categories.map(c => {
            return {
                value: c.subcategoryId,
                text: c.incidentCategory,
            };
        });

        var locationData = incidentDetails.map(l => {
            return {
                value: l.itLocationId,
                text: l.description,
            };
        });
        var defaultDropdownOption = { value: '', text: '' };
        locationData.unshift(defaultDropdownOption);        
        // Build category dropdown
        var categoryOpts = {
            label: 'Incident Category',  
            id: 'incidentCategory',
            readOnly: formReadOnly,
            data: categoryData,          
        };       
        categoryDropdown = new Select(categoryOpts);
        categoryDropdown.setValue(categoryId);

        // Build location dropdown
        var locationOpts = {
            label: 'Location Detail',   
            id: 'incidentLocation',
            readOnly: formReadOnly,
            data: locationData            
        };        
        locationDetailDropdown = new Select(locationOpts);
        locationDetailDropdown.setValue(locationId);

        // Append to wrapper
        categoryDropdown.rootElement.style.marginTop = '-20px';
        locationDetailDropdown.rootElement.style.marginTop = '-20px';
        container.appendChild(categoryDropdown.rootElement);
        container.appendChild(locationDetailDropdown.rootElement);

        return container;
    }
    
    function buildTextAreas() {
        var container = document.createElement('div');
        container.classList.add('minheight');
        var textAreaOpts = {
            style: 'secondary',
            type: 'textarea',  
            fullscreen: true,
        };      

        summaryTextarea = new Textarea({
            ...textAreaOpts,            
            label: 'Summary of Incident',             
        });
       
        summaryTextarea.rootElement.style.marginBottom = '40px';
        var summaryTA = summaryTextarea.input;
        if (summaryTA) {
            summaryTA.style.minHeight = '80px';
            summaryTA.classList.add('summary');
        }

        actionTextarea = new Textarea({
            ...textAreaOpts,
            label: 'Immediate Action',                       
        });
        actionTextarea.rootElement.style.marginBottom = '40px';
        var actionTA = actionTextarea.input;
        if (actionTA) {
            actionTA.style.minHeight = '80px';
            actionTA.classList.add('action');
        }

        preventionTextarea = new Textarea({
            ...textAreaOpts,
            label: 'Prevention Plan',                     
        });
        preventionTextarea.rootElement.style.marginBottom = '40px';
        var preventionTA = preventionTextarea.input;
        if (preventionTA) {
            preventionTA.style.minHeight = '80px';
            preventionTA.classList.add('prevention');
        }

        causeTextarea = new Textarea({
            ...textAreaOpts,
            label: 'Cause & Contributing Factors',                      
        });
        causeTextarea.rootElement.style.marginBottom = '40px';
        var causeTA = causeTextarea.input;
        if (causeTA) {
            causeTA.style.minHeight = '80px';
            causeTA.classList.add('factors');
        }

        container.appendChild(summaryTextarea.rootElement);       
        container.appendChild(actionTextarea.rootElement);
        if ($.session.incidentTrackingShowPreventionPlan) {
            container.appendChild(preventionTextarea.rootElement);
        }
        if ($.session.incidentTrackingShowCauseAndContributingFactors) {
            container.appendChild(causeTextarea.rootElement);
        }

        return container;
    }

    async function fetchAllConsumers() {
        var getConsumerByGroupData = {
            selectedGroupCode: 'All',
            selectedGroupId: '0',
            selectedLocationId: '0',
            selectedDate: UTIL.getTodaysDate(),
            selectedActive: 'No',
            isCaseLoad: false
        };

        try {
            var response = await rosterAjax.getConsumersByGroup(getConsumerByGroupData);
            allConsumersForDropdown = response.getConsumersByGroupJSONResult || [];
        } catch (error) {
            console.error('Error fetching consumers:', error);
            allConsumersForDropdown = [];
        }
    }
    function buildIndividualsInvolvedSection() {
        var sectionContainer = document.createElement('div');
        sectionContainer.style.marginTop = '-20px';
       
        var heading = document.createElement('h3');
        heading.textContent = 'Individuals Involved';        
        heading.style.fontSize = '18px';
        heading.style.fontWeight = 'bold';
        heading.style.marginBottom = '15px';        
        individualErrorIcon = document.createElement('div');
        individualErrorIcon.id = 'individualErrorIcon';      
        individualErrorIcon.classList.add('errorIcon');
        individualErrorIcon.classList.add('hidden');
        individualErrorIcon.innerHTML = icons['error'];      
        heading.appendChild(individualErrorIcon);
        sectionContainer.appendChild(heading);

        individualsTable = table.build({
            tableId: 'individualsInvolvedTable',
            columnHeadings: ['Individual', 'Involvement'],
            endIcon: true
        });
        individualsTable.style.marginBottom = '15px';
        sectionContainer.appendChild(individualsTable);

        // Populate table with consumers already in this incident
        individualsInvolvedData = [];
        if (SelectedIncidentId == 0) {  
            let locId = SelectedConsumer.locationId?.split('|')[0] || '';
            individualsInvolvedData.push({
                consumerInvolvedId: 'temp_' + SelectedConsumer.id,
                consumerId: SelectedConsumer.id,
                firstName: SelectedConsumer.firstName,
                lastName: SelectedConsumer.lastName,
                middleName: SelectedConsumer.middleName,
                involvementType: 'At Fault',
                involvementTypeId: '',
                locationId: locId,
                includeInCount: 'Y'
            });
        }
        if (reviewData && reviewData.itConsumerInvolved && reviewData.itConsumerInvolved.length > 0) {
            individualsInvolvedData = reviewData.itConsumerInvolved.map(c => ({
                consumerInvolvedId: c.consumerInvolvedId,
                consumerId: c.consumerId,
                firstName: c.firstName,
                lastName: c.lastName,
                middleName: c.middleName,
                involvementType: c.involvementDescription,
                involvementTypeId: c.involvementId,
                locationId: c.locationId,
                includeInCount: c.includeInCount
            }));
        }
        populateIndividualsTable(); 

        var addIndividualBtnWrap = document.createElement('div');
        addIndividualBtnWrap.style.display = 'flex';
        addIndividualBtnWrap.style.justifyContent = 'flex-end';
        addIndividualBtnWrap.style.marginBottom = '15px';
        addIndividualBtnWrap.style.textAlign = 'right';
        var addIndividualBtn = button.build({
            id: 'addIndividualBtn',
            text: 'ADD INDIVIDUAL',
            style: 'secondary',
            type: 'contained',
            callback: function () {
                individualDropdown.select.classList.remove('disabled');
                showNewIndividualForm();
            }
        });
        if (!isreadOnly()) {
            addIndividualBtnWrap.appendChild(addIndividualBtn);
        }       
        sectionContainer.appendChild(addIndividualBtnWrap);

        // Individual Form (hidden by default)
        var individualFormSection = document.createElement('div');
        individualFormSection.id = 'individualFormSection';
        individualFormSection.style.display = 'none';
        individualFormSection.style.marginBottom = '30px';
        individualFormSection.style.padding = '20px';
        individualFormSection.style.border = '1px solid #ddd';
        individualFormSection.style.borderRadius = '4px';
        individualFormSection.style.backgroundColor = '#f9f9f9';

        var individualFormGrid = document.createElement('div');
        individualFormGrid.style.display = 'grid';
        individualFormGrid.style.gridTemplateColumns = '1fr 1fr';
        individualFormGrid.style.gap = '20px';  
        
        // POPULATE INDIVIDUAL DROPDOWN - Use ALL consumers from the system
        var consumerData = allConsumersForDropdown.map(consumer => ({
            value: consumer.id,
            text: `${consumer.LN}, ${consumer.FN} ${consumer.MN || ''}`
        }));
        consumerData.unshift({ value: '', text: '' });
        var individualDropdown = new Select({
            data: consumerData,
            id: 'individualDropdown',
            label: 'Individual*',
            style: 'secondary',
            className: 'individualDropdown',           
        });
        individualFormGrid.appendChild(individualDropdown.rootElement);
        individualDropdown.select.addEventListener('change', e => {          
            loadConsumerServiceLocations(e.target.value);  
        });
        var involvementTypes = incidentTracking.getInvolvementTypes();
        var involvementData = involvementTypes.map(it => {
            var involvementId = it.involvementId;
            return { value: involvementId, text: it.description };
        });
        involvementData.unshift({ value: '', text: '' });
        var individualInvolvementDropdown = new Select({
            data: involvementData,
            id: 'individualInvolvementDropdown',
            label: 'Involvement*',
            style: 'secondary',
            className: 'involvementDropdown',           
        });
        individualFormGrid.appendChild(individualInvolvementDropdown.rootElement);
        individualInvolvementDropdown.select.addEventListener('change', e => {
            validateIndividualForm();
        });
        individualFormSection.appendChild(individualFormGrid);

        var locationDropdown = new Select({
            data:[],
            id:'individualLocationDropdown',
            label: 'Location*',
            style: 'secondary',
            className: 'locationDropdown' 
            
        });
        locationDropdown.select.addEventListener('change', e => {
            validateIndividualForm();
        });           
        var includeInCountsWrap = document.createElement('div');
        includeInCountsWrap.style.marginTop = '25px';
        var includeInCountsCheckbox = input.buildCheckbox({
            text: 'Include in Counts',
            isChecked: false
        });       
        includeInCountsWrap.appendChild(includeInCountsCheckbox);       
        var grid2 = document.createElement('div');
        grid2.style.display = 'grid';
        grid2.style.gridTemplateColumns = '1fr 1fr';
        grid2.style.gap = '20px'; 
        grid2.appendChild(locationDropdown.rootElement);
        grid2.appendChild(includeInCountsWrap);
        individualFormSection.appendChild(grid2);        
        var individualFormBtnWrap = document.createElement('div');
        individualFormBtnWrap.style.display = 'flex';
        individualFormBtnWrap.style.gap = '10px';
        individualFormBtnWrap.style.justifyContent = 'flex-end';

        var individualSaveBtn = button.build({
            id: 'individualSaveBtn',
            text: 'SAVE',
            type: 'contained',
            style: 'secondary',
            callback: function () {
                var indivSelect = document.getElementById('individualDropdown');
                var involvementSelect = document.getElementById('individualInvolvementDropdown');
                var locationSelect = document.getElementById('individualLocationDropdown');
                var includeCheckbox = individualFormSection.querySelector('input[type="checkbox"]');

                var editId = individualFormSection.getAttribute('data-edit-row-id');
                var cId = indivSelect.value;
                var involvementText = involvementSelect.options[involvementSelect.selectedIndex].text;
                var isExists = individualsInvolvedData.filter(d => d.consumerId === cId);
                if ((editId||0) === 0 && isExists && isExists.length > 0) {
                    failSave.show('This individual is already exists.');
                    setTimeout(() => { failSave.hide(); }, 3000);
                    return;
                }
                else {
                    // Get location name
                    var locationName = '';
                    if (locationSelect.value) {
                        var loc = involvementLocations.find(l => l.id === locationSelect.value);
                        locationName = loc ? loc.text : '';
                    }

                    var includeInCountVal = includeCheckbox.checked ? 'Y' : 'N';

                    if (editId) {

                        // Update individualsInvolvedData array
                        var dataIndex = individualsInvolvedData.findIndex(d =>
                            (d.consumerInvolvedId && d.consumerInvolvedId === editId) ||
                            (d.consumerId === cId)
                        );
                        if (dataIndex !== -1) {
                            individualsInvolvedData[dataIndex].involvementTypeId = involvementSelect.value;
                            individualsInvolvedData[dataIndex].involvementType = involvementText;
                            individualsInvolvedData[dataIndex].locationId = locationSelect.value;
                            individualsInvolvedData[dataIndex].includeInCount = includeInCountVal;
                        }

                    } else {

                        // Add to individualsInvolvedData
                        let individual = allConsumersForDropdown.filter(c => c.id === cId)[0];
                        individualsInvolvedData.push({
                            consumerInvolvedId: 'temp_' + cId,
                            consumerId: cId,
                            firstName: individual.FN || '',
                            lastName: individual.LN || '',
                            middleName: individual.MN || '',
                            involvementTypeId: involvementSelect.value,
                            involvementType: involvementText,
                            locationId: locationSelect.value,
                            includeInCount: includeInCountVal
                        });

                    }
                    populateIndividualsTable();
                    individualFormSection.removeAttribute('data-edit-row-id');
                    individualFormSection.style.display = 'none';
                    addIndividualBtn.classList.remove('hidden');
                    checkRequiredFields(false);
                }
            }
        });
       
        var individualCancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: function () {
                individualFormSection.removeAttribute('data-edit-row-id');
                individualFormSection.style.display = 'none';
                addIndividualBtn.classList.remove('hidden');
                var nameSelect = document.getElementById('individualDropdown')
                var involvementSelect = document.getElementById('individualInvolvementDropdown');
                var location = document.getElementById('individualLocationDropdown');
                nameSelect.classList.remove('error');
                nameSelect.classList.remove('disabled');
                involvementSelect.classList.remove('error');
                location.classList.remove('error');
                checkRequiredFields(false);
            }
        });

        if (!isreadOnly()) {
            individualFormBtnWrap.appendChild(individualSaveBtn);
        }
       
        individualFormBtnWrap.appendChild(individualCancelBtn);
        individualFormSection.appendChild(individualFormBtnWrap);

        sectionContainer.appendChild(individualFormSection);
        loadConsumerServiceLocations(SelectedConsumer?.id || individualsInvolvedData[0].consumerId);    
        function showDeleteWarning(id) {
            var deleteWarningPopup = POPUP.build({});
            var message = document.createElement('p');
            message.innerHTML = 'Are you sure you want to remove this record?';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var yesBtn = button.build({
                text: 'Yes',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    // Remove from data array
                    individualsInvolvedData = individualsInvolvedData.filter(d =>
                        d.consumerInvolvedId !== id
                    );
                    populateIndividualsTable();
                    POPUP.hide(deleteWarningPopup);
                }
            });
            var noBtn = button.build({
                text: 'No',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(deleteWarningPopup);
                }
            });
            btnWrap.appendChild(yesBtn);
            btnWrap.appendChild(noBtn);
            deleteWarningPopup.appendChild(message);
            deleteWarningPopup.appendChild(btnWrap);
            POPUP.show(deleteWarningPopup);
        }
        function loadConsumerServiceLocations(consumerId,locationId) {
            involvementLocations = [];
            incidentTrackingAjax.getConsumerServiceLocations(consumerId, results => {
                involvementLocations = results.map(r => {
                    return {
                        id: r.locationId,
                        value: r.locationId,
                        text: r.description
                    };
                });
                locationId = locationId || involvementLocations[0]?.id||'';
                involvementLocations.unshift({ value: '', text: '' });
                locationDropdown.populate(involvementLocations, locationId);
                if (individualFormSection.style.display !== 'none') {
                    validateIndividualForm();
                }
            });
        }
        // Add click event to table rows for EDIT
        individualsTable.addEventListener('click', function (e) {
            var row = e.target.closest('div.table__row');           
            // Handle row click for EDIT
            if (row && row.dataset.id && !e.target.closest('.endIcon')) {               
                // Populate form with row data
                var consumerIdAttr = row.getAttribute('data-consumer-id');
                var involvementIdAttr = row.getAttribute('data-involvement-id');
                var locationIdAttr = row.getAttribute('data-location-id');
                var includeCount = row.getAttribute('data-include-count') === 'Y';

                // Re-populate individual dropdown with ALL consumers and pre-select the current one
                var indivDropdownContainer = document.getElementById('individualDropdown');
                if (indivDropdownContainer) {
                    indivDropdownContainer.value = consumerIdAttr;
                    if (SelectedIncidentId > 0) {
                        indivDropdownContainer.classList.add('disabled');
                    }
                }
                // Populate other dropdowns
                var involvementDropdown = document.getElementById('individualInvolvementDropdown');
                if (involvementDropdown) {
                    involvementDropdown.value = involvementIdAttr || '';
                }

                var locationDropdown = document.getElementById('individualLocationDropdown');
                if (locationDropdown) {
                    loadConsumerServiceLocations(consumerIdAttr, locationIdAttr);                    
                }

                var checkbox = individualFormSection.querySelector('input[type="checkbox"]');
                if (checkbox) {
                    checkbox.checked = includeCount;
                }

                // Mark form as editing this row
                individualFormSection.setAttribute('data-edit-row-id', row.dataset.id);

                individualFormSection.style.display = 'block';
                addIndividualBtn.classList.add('hidden');
                if (locationIdAttr !== 0) {
                    validateIndividualForm();
                }
            }

            // Handle delete icon click
            if (e.target.closest('.endIcon') && $.session.incidentTrackingDelete) {
                if (row) {
                    var rowId = row.dataset.id;
                    showDeleteWarning(rowId);
                }
            }
        });

        return sectionContainer;
    }
    function populateIndividualsTable() {
        var tbody = individualsTable.querySelector('.table__body') || individualsTable.querySelector('tbody');
        tbody.innerHTML = ''; // Clear existing rows
        individualsInvolvedData = individualsInvolvedData.sort((a, b) =>
            a.lastName.localeCompare(b.lastName, undefined, { sensitivity: "base" }));
        var involvementTypes = incidentTracking.getInvolvementTypes();
        for (var _index = 0; _index < individualsInvolvedData.length; _index++) {
            if (!individualsInvolvedData[_index].involvementTypeId) {
                let involvement = involvementTypes.filter(it => it.description === 'At Fault')[0];
                individualsInvolvedData[_index].involvementTypeId = involvement?.involvementId;
            }
        }    
        individualsInvolvedData.forEach(consumer => {
            var tr = document.createElement('div');
            tr.classList.add('table__row', 'disabledRow');
            tr.dataset.id = consumer.consumerInvolvedId;
           
            // Store all data in attributes
            tr.setAttribute('data-consumer-id', consumer.consumerId || consumer.id);
            tr.setAttribute('data-first-name', consumer.firstName);
            tr.setAttribute('data-last-name', consumer.lastName);
            tr.setAttribute('data-involvement-type', consumer.involvementType || '');
            tr.setAttribute('data-involvement-id', consumer.involvementTypeId || '');
            tr.setAttribute('data-location-id', consumer.locationId || '');
            tr.setAttribute('data-include-count', consumer.includeInCount || 'N');

            // Get location name
            var locationName = '';
            if (consumer.locationId) {
                var loc = incidentLocations.find(l => l.ID === consumer.locationId);
                locationName = loc ? loc.description : '';
            }

            var cell1 = document.createElement('div');
            cell1.textContent = `${consumer.lastName}, ${consumer.firstName} ${consumer.middleName||''}`;

            var cell2 = document.createElement('div');
            cell2.textContent = consumer.involvementType || '';

            var cell3 = document.createElement('div');
            cell3.className = 'endIcon';
            cell3.style.textAlign = 'right';
            cell3.innerHTML = $.session.incidentTrackingDelete ? icons['delete'] : '';

            tr.appendChild(cell1);
            tr.appendChild(cell2);
            tr.appendChild(cell3);

            tbody.appendChild(tr);
        });       
        if (individualsInvolvedData.length === 0) {
            var tr = document.createElement('div');
            tr.classList.add('table__row', 'disabledRow');
            tr.setAttribute('colspan', '3');
            var errorCell = document.createElement('div');
            errorCell.classList.add('error');
            errorCell.textContent = 'You must select at least one consumer';
            tr.appendChild(errorCell);
            tbody.appendChild(tr);
            if (individualErrorIcon) {
                individualErrorIcon.classList.remove('hidden');
                checkRequiredFields(true);
            }
        }
        else {
            if (individualErrorIcon) {
                individualErrorIcon.classList.add('hidden');
            }
            checkRequiredFields(false);
        }
        var individualNavContainer = document.querySelector('.individuals_involved_list');
        individualNavContainer.innerHTML = '';
        var navItems = updateIndividualNavMenuItems();
        navItems.forEach(item => { individualNavContainer.appendChild(item) });
    }
    function showNewIndividualForm() {
        var individualFormSection = document.getElementById('individualFormSection');
        // Clear form for new entry       
        const locationDropdown = document.getElementById('individualLocationDropdown');    
        [...locationDropdown.options].forEach(option => {
            if (option.value !== "") {
                option.remove();
            }
        });
        individualFormSection.removeAttribute('data-edit-row-id');
        var selects = individualFormSection.querySelectorAll('select');
        selects.forEach(s => s.value = '');
        var checkbox = individualFormSection.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = true;
        individualFormSection.style.display = 'block';
        let addIndividualBtn = document.getElementById('addIndividualBtn');
        addIndividualBtn.classList.add('hidden');
        validateIndividualForm();
    }
    function validateIndividualForm() {
        var individualFormSection = document.getElementById('individualFormSection');
        var individualSaveBtn = document.getElementById('individualSaveBtn');
        var nameSelect = document.getElementById('individualDropdown');
        var involvementSelect = document.getElementById('individualInvolvementDropdown');
        var location = document.getElementById('individualLocationDropdown');

        if (!nameSelect.value || nameSelect.value === '') {
            nameSelect.classList.add('error');
        }
        else {
            nameSelect.classList.remove('error');
        }
        if (!involvementSelect.value || involvementSelect.value === '') {
            involvementSelect.classList.add('error');
        }
        else {
            involvementSelect.classList.remove('error');
        }
        if (!location.value || location.value === '') {
            location.classList.add('error');
        }
        else {
            location.classList.remove('error');
        }

        var hasErrors = [].slice.call(individualFormSection.querySelectorAll('.error:not(button)'));
        if (hasErrors.length === 0) {
            if (!isreadOnly()) {
                individualSaveBtn.classList.remove('disabled');
            }          

        } else {
            individualSaveBtn.classList.add('disabled');
        }
        checkRequiredFields(hasErrors.length > 0);
    }
    function buildEmployeesInvolvedSection() {
        var sectionContainer = document.createElement('div');
        sectionContainer.style.marginTop = '-10px';

        var heading = document.createElement('h3');
        heading.textContent = 'Employees Involved';
        heading.style.fontSize = '18px';
        heading.style.fontWeight = 'bold';
        heading.style.marginBottom = '15px';
        sectionContainer.appendChild(heading);

        employeesTable = table.build({
            tableId: 'employeesInvolvedTable',
            columnHeadings: ['Employee', 'Involvement'],
            endIcon: true
        });
        employeesTable.style.marginBottom = '15px';
        sectionContainer.appendChild(employeesTable);
        // Initialize employeesInvolvedData if it doesn't exist
        if (!employeesInvolvedData) {
            employeesInvolvedData = [];
        }      
        if (reviewData && reviewData.itEmployeesInvolved && reviewData.itEmployeesInvolved.length > 0) {
            employeesInvolvedData = reviewData.itEmployeesInvolved.map(e => ({
                employeeInvolvedId: e.employeeInvolvedId,
                employeeId: e.employeeId,
                employeeInvolvementTypeId: e.employeeInvolvementTypeId,
                description: e.description,
                notifyEmployee: e.notifyEmployee,
                lastName: e.lastName,
                firstName: e.firstName
            }));
        }

        populateEmployeeTable();  
        var addEmployeeBtnWrap = document.createElement('div');
        addEmployeeBtnWrap.style.display = 'flex';
        addEmployeeBtnWrap.style.justifyContent = 'flex-end';
        addEmployeeBtnWrap.style.marginBottom = '15px';
        addEmployeeBtnWrap.style.textAlign = 'right';
        var addEmployeeBtn = button.build({
            text: 'ADD EMPLOYEE',
            style: 'secondary',
            type: 'contained',
            callback: function () {
                var employeeFormSection = document.getElementById('employeeFormSection');
                // Clear form for new entry
                employeeFormSection.removeAttribute('data-edit-row-id');
                var nameSelect = employeeFormSection.querySelector('select.employeeNameDropdown');
                var involvementSelect = employeeFormSection.querySelector('select.involvmentTypeDropdown');
                var notifyCheckbox = employeeFormSection.querySelector('input[type="checkbox"]');
                if (nameSelect) nameSelect.value = '';
                if (involvementSelect) involvementSelect.value = '';
                if (notifyCheckbox) notifyCheckbox.checked = false;

                employeeFormSection.style.display = 'block';
                addEmployeeBtn.classList.add('hidden');
                validateEmployeeForm();
            }
        });
        if (!isreadOnly()) {
            addEmployeeBtnWrap.appendChild(addEmployeeBtn);
        }        
        sectionContainer.appendChild(addEmployeeBtnWrap);

        // Employee Form (hidden by default)
        var employeeFormSection = document.createElement('div');
        employeeFormSection.id = 'employeeFormSection';
        employeeFormSection.style.display = 'none';
        employeeFormSection.style.marginBottom = '30px';
        employeeFormSection.style.padding = '20px';
        employeeFormSection.style.border = '1px solid #ddd';
        employeeFormSection.style.borderRadius = '4px';
        employeeFormSection.style.backgroundColor = '#f9f9f9';

        var employeeGrid = document.createElement('div');
        employeeGrid.style.display = 'grid';
        employeeGrid.style.gridTemplateColumns = '1fr 1fr';
        employeeGrid.style.gap = '20px';
        employeeGrid.style.marginBottom = '15px';

        // Employee Name Dropdown
        var employeeNames = incidentTracking.getEmployeeNames();
        var employeeData = employeeNames.map(n => {
            return {
                value: n.employeeId,
                text: n.employeeName,
            };
        });
        employeeData.unshift({ value: '', text: '' });
        var employeeDropdown = new Select({
            data: employeeData,
            id: 'employeeNameDropdown',
            className: 'employeeNameDropdown',
            label: 'Employee*',
            style: 'secondary'           
        });
        employeeGrid.appendChild(employeeDropdown.rootElement);
        employeeDropdown.select.addEventListener('change', e => {
            validateEmployeeForm();
        });
        // Employee Involvement Dropdown
        var involvementTypes = incidentTracking.getInvolvementTypes();
        var involvementData = involvementTypes.map(it => {
            var involvementId = it.involvementId === '%' ? '' : it.involvementId;
            return { value: involvementId, text: it.description };
        });
        involvementData.unshift({ value: '', text: '' });
        var employeeInvolvementDropdown = new Select({
            data: involvementData,
            id:'involvmentTypeDropdown',
            className: 'involvmentTypeDropdown',
            label: 'Involvement*',
            style: 'secondary'                 
        });
        employeeGrid.appendChild(employeeInvolvementDropdown.rootElement);
        employeeFormSection.appendChild(employeeGrid);
        employeeInvolvementDropdown.select.addEventListener('change', e => {
            validateEmployeeForm();
        });
        var notifyCheckboxWrap = document.createElement('div');
        notifyCheckboxWrap.style.marginBottom = '15px';
        var notifyCheckbox = input.buildCheckbox({
            text: 'Notify Employee',
            isChecked: false
        });
        notifyCheckboxWrap.appendChild(notifyCheckbox);
        employeeFormSection.appendChild(notifyCheckboxWrap);

        var employeeFormBtnWrap = document.createElement('div');
        employeeFormBtnWrap.style.display = 'flex';
        employeeFormBtnWrap.style.gap = '10px';
        employeeFormBtnWrap.style.justifyContent = 'flex-end';
        function validateEmployeeForm() {
            var nameSelect = document.getElementById('employeeNameDropdown');
            var involvementSelect = document.getElementById('involvmentTypeDropdown');

            if (!nameSelect.value || nameSelect.value === '') {
                nameSelect.classList.add('error');
            }
            else {
                nameSelect.classList.remove('error');
            }
            if (!involvementSelect.value || involvementSelect.value === '') {
                involvementSelect.classList.add('error');
            }
            else {
                involvementSelect.classList.remove('error');
            }

            var hasErrors = [].slice.call(employeeFormSection.querySelectorAll('.error:not(button)'));
            if (hasErrors.length === 0) {
                if (!isreadOnly()) {
                    employeeSaveBtn.classList.remove('disabled');
                }         
               
            } else {
                employeeSaveBtn.classList.add('disabled');
            }
            checkRequiredFields(hasErrors.length > 0);
        }
        var employeeSaveBtn = button.build({
            text: 'SAVE',
            type: 'contained',
            style: 'secondary',
            callback: function () {
                // Find select elements - they have the class directly on them
                var nameSelect = document.getElementById('employeeNameDropdown');
                var involvementSelect = document.getElementById('involvmentTypeDropdown');
                var notifyCheckbox = employeeFormSection.querySelector('input[type="checkbox"]');

                // Get selected employee ID from the option's data attribute
                var selectedOption = nameSelect.options[nameSelect.selectedIndex];
                var employeeId = selectedOption.value;
                var employeeName = selectedOption.text;

                // Get involvement text
                var involvementText = involvementSelect.options[involvementSelect.selectedIndex].text;

                var tbody = employeesTable.querySelector('.table__body') || employeesTable.querySelector('tbody');
                var editId = employeeFormSection.getAttribute('data-edit-row-id');

                var row = editId ? tbody.querySelector(`div[data-id="${editId}"]`) : null;
                if (!employeesInvolvedData) employeesInvolvedData = [];
                if (editId) {
                    var dataIndex = employeesInvolvedData.findIndex(d => d.employeeInvolvedId === editId);
                    if (dataIndex !== -1) {
                        employeesInvolvedData[dataIndex].employeeId = employeeId;
                        employeesInvolvedData[dataIndex].employeeInvolvementTypeId = involvementSelect.value;
                        employeesInvolvedData[dataIndex].description = involvementText;
                        employeesInvolvedData[dataIndex].notifyEmployee = notifyCheckbox && notifyCheckbox.checked ? 'Y' : 'N';
                        employeesInvolvedData[dataIndex].lastName = employeeName.split(',')[0]?.trim() || '';
                        employeesInvolvedData[dataIndex].firstName = employeeName.split(',')[1]?.trim() || '';
                    }
                }
                else {
                    const check = employeesInvolvedData.filter(d => d.employeeId === employeeId);
                    if (!check || check.length == 0) {
                        employeesInvolvedData.push({
                            employeeInvolvedId: 'temp_' + Date.now(),
                            employeeId: employeeId,
                            employeeInvolvementTypeId: involvementSelect.value,
                            description: involvementText,
                            notifyEmployee: notifyCheckbox && notifyCheckbox.checked ? 'Y' : 'N',
                            lastName: employeeName.split(',')[0]?.trim() || '',
                            firstName: employeeName.split(',')[1]?.trim() || ''
                        });
                    }
                    else {
                        failSave.show('Employee already exists!!');
                        setTimeout(() => { failSave.hide(); }, 3000);
                    }
                }
                populateEmployeeTable();

                // Clear form and hide
                employeeFormSection.removeAttribute('data-edit-row-id');
                nameSelect.value = '';
                involvementSelect.value = '';
                if (notifyCheckbox) notifyCheckbox.checked = false;
                employeeFormSection.style.display = 'none';
                addEmployeeBtn.classList.remove('hidden');
                checkRequiredFields(false);
            }
        });
      
        var employeeCancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: function () {
                employeeFormSection.removeAttribute('data-edit-row-id');
                var nameSelect = document.getElementById('employeeNameDropdown');
                var involvementSelect = document.getElementById('involvmentTypeDropdown');
                var notifyCheckbox = employeeFormSection.querySelector('input[type="checkbox"]');

                if (nameSelect) nameSelect.value = '';
                if (involvementSelect) involvementSelect.value = '';
                if (notifyCheckbox) notifyCheckbox.checked = false;
                involvementSelect.classList.remove('error');
                nameSelect.classList.remove('error');
                employeeFormSection.style.display = 'none';
                addEmployeeBtn.classList.remove('hidden');
                checkRequiredFields(false);
            }
        });

        if (!isreadOnly()) {
            employeeFormBtnWrap.appendChild(employeeSaveBtn);
        }
       
        employeeFormBtnWrap.appendChild(employeeCancelBtn);
        employeeFormSection.appendChild(employeeFormBtnWrap);
        function showDeleteWarning(id) {
            var deleteWarningPopup = POPUP.build({});
            var message = document.createElement('p');
            message.innerHTML = 'Are you sure you want to remove this record?';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var yesBtn = button.build({
                text: 'Yes',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    // Remove from data array
                    employeesInvolvedData = employeesInvolvedData.filter(d => d.employeeInvolvedId !== id);
                    populateEmployeeTable();
                    POPUP.hide(deleteWarningPopup);
                }
            });
            var noBtn = button.build({
                text: 'No',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(deleteWarningPopup);
                }
            });
            btnWrap.appendChild(yesBtn);
            btnWrap.appendChild(noBtn);
            deleteWarningPopup.appendChild(message);
            deleteWarningPopup.appendChild(btnWrap);
            POPUP.show(deleteWarningPopup);
        }
        sectionContainer.appendChild(employeeFormSection);

        // Add click event to table rows for EDIT and DELETE
        employeesTable.addEventListener('click', function (e) {

            // Handle delete icon click
            if (e.target.classList.contains('endIcon') && $.session.incidentTrackingDelete) {
                var row = e.target.closest('.table__row');
                let rowId = row.dataset.id;

                showDeleteWarning(rowId);
                return;
            }

            if (e.target.parentElement.classList.contains('header')) return;
            if (!e.target.classList.contains('table__row')) return;

            // Handle row click for EDIT
            if (!e.target.classList.contains('endIcon')) {
                var row = e.target.closest('div');                
                // Get stored data
                var employeeId = row.getAttribute('data-employee-id');
                var involvementId = row.getAttribute('data-involvement-id');
                var notify = row.getAttribute('data-notify') === 'true';

                // Populate form
                var nameSelect = document.getElementById('employeeNameDropdown');
                var involvementSelect = document.getElementById('involvmentTypeDropdown');
                var notifyCheckbox = employeeFormSection.querySelector('input[type="checkbox"]');

                nameSelect.value = employeeId;
                involvementSelect.value = involvementId;
                notifyCheckbox.checked = notify;

                // Mark as editing
                employeeFormSection.setAttribute('data-edit-row-id', row.dataset.id);

                employeeFormSection.style.display = 'block';
                addEmployeeBtn.classList.add('hidden');
                validateEmployeeForm();
            }
        });

        return sectionContainer;
    }
    function populateEmployeeTable() {
        var tbody = employeesTable.querySelector('.table__body') || employeesTable.querySelector('tbody');
        tbody.innerHTML = '';
        employeesInvolvedData = employeesInvolvedData.sort((a, b) =>
            a.lastName.localeCompare(b.lastName, undefined, { sensitivity: "base" }));
        employeesInvolvedData.forEach(emp => {
            var tr = document.createElement('div');
            tr.classList.add('table__row', 'disabledRow');
            tr.dataset.id = emp.employeeInvolvedId;

            // Store data attributes for save
            tr.setAttribute('data-employee-id', emp.employeeId);
            tr.setAttribute('data-involvement-id', emp.employeeInvolvementTypeId);
            tr.setAttribute('data-notify', emp.notifyEmployee === 'Y' ? 'true' : 'false');
            tr.setAttribute('data-employee-name', `${emp.lastName}, ${emp.firstName}`);

            var cell1 = document.createElement('div');
            cell1.textContent = `${emp.lastName}, ${emp.firstName}`;

            var cell2 = document.createElement('div');
            cell2.textContent = emp.description || '';

            var cell3 = document.createElement('div');
            cell3.className = 'endIcon';
            cell3.style.textAlign = 'right';
            cell3.style.width = '50px';
            cell3.innerHTML = $.session.incidentTrackingDelete ? icons['delete'] : '';

            tr.appendChild(cell1);
            tr.appendChild(cell2);
            tr.appendChild(cell3);

            tbody.appendChild(tr);
        });
    }
    function displayOtherPeopleCount() {
        var table = document.getElementById('otherPeopleInvolvedTable');
        if (!table) return;

        var rows = table.querySelectorAll('tbody tr');
        var count = rows ? rows.length : 0;
        var countHolder = document.querySelector('#otherPeopleSection span[data-count="people"]');
        if (countHolder) {
            countHolder.innerHTML = `( ${count} )`;
        }
    }
    function buildOtherPersonCard(values) {
        // values = {name, company, involvementTypeId, address1, address2, city, state, zipCode, phone}
        var name = values ? values.name : '';
        var company = values ? values.company : '';
        var involvementId = values ? values.involvementTypeId : '';
        var address1 = values ? values.address1 : '';
        var address2 = values ? values.address2 : '';
        var city = values ? values.city : '';
        var state = values ? values.state : '';
        var zip = values ? values.zipCode : '';
        var phone = values ? values.phone : '';

        var otherPeopleRow = document.createElement('div');
        otherPeopleRow.classList.add('peopleRow');
        otherPeopleRow.style.marginBottom = '20px';
        otherPeopleRow.style.padding = '20px';
        otherPeopleRow.style.border = '1px solid #ddd';
        otherPeopleRow.style.borderRadius = '4px';
        otherPeopleRow.style.backgroundColor = '#f9f9f9';

        var nameInput = input.build({
            label: 'Name',
            type: 'text',
            style: 'secondary',
            classNames: ['name'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: name,
            callbackType: 'input'           
        });

        var companyInput = input.build({
            label: 'Company',
            type: 'text',
            style: 'secondary',
            classNames: ['company'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: company,
        });

        var involvementDropdown = dropdown.build({
            label: 'Involvement Type',
            style: 'secondary',
            className: 'involvmentTypeDropdown'            
        });

        var address1Input = input.build({
            label: 'Address 1',
            type: 'text',
            style: 'secondary',
            classNames: ['address1'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: address1,
        });

        var address2Input = input.build({
            label: 'Address 2',
            type: 'text',
            style: 'secondary',
            classNames: ['address2'],
            attributes: [{ key: 'maxlength', value: '50' }],
            value: address2,
        });

        var cityInput = input.build({
            label: 'City',
            type: 'text',
            style: 'secondary',
            classNames: ['city'],
            attributes: [{ key: 'maxlength', value: '27' }],
            value: city,
        });

        var stateInput = input.build({
            label: 'State',
            type: 'text',
            style: 'secondary',
            classNames: ['state'],
            attributes: [{ key: 'maxlength', value: '2' }],
            value: state,
        });

        var zipInput = input.build({
            label: 'Zip Code',
            type: 'text',
            style: 'secondary',
            classNames: ['zip'],
            attributes: [{ key: 'maxlength', value: '9' }],
            value: zip,
        });

        var phoneInput = input.build({
            label: 'Phone',
            type: 'tel',
            style: 'secondary',
            classNames: ['phone'],
            attributes: [{ key: 'maxlength', value: '14' }],
            value: phone,
        });
      

        // Populate dropdowns
        var involvementTypes = incidentTracking.getInvolvementTypes();
        var involvementDropdownData = involvementTypes.map(it => {
            var involvementIdValue = it.involvementId === '%' ? '' : it.involvementId;
            return { value: involvementIdValue, text: it.description };
        });
        var defaultValue = { value: '', text: '' };
        involvementDropdownData.unshift(defaultValue);
        dropdown.populate(involvementDropdown, involvementDropdownData, involvementId);

        if (!involvementId) {
            involvementDropdown.classList.add('error');
        }

        // Build card layout
        var wrap1 = document.createElement('div');
        var wrap2 = document.createElement('div');
        var wrap3 = document.createElement('div');
        var wrap4 = document.createElement('div');
        wrap1.style.display = 'grid';
        wrap1.style.gridTemplateColumns = '1fr 1fr';
        wrap1.style.gap = '20px';
        wrap1.style.marginBottom = '15px';
        wrap2.style.display = 'grid';
        wrap2.style.gridTemplateColumns = '1fr 1fr';
        wrap2.style.gap = '20px';
        wrap2.style.marginBottom = '15px';
        wrap3.style.display = 'grid';
        wrap3.style.gridTemplateColumns = '1fr 1fr 1fr';
        wrap3.style.gap = '20px';
        wrap3.style.marginBottom = '15px';
        wrap4.style.display = 'grid';
        wrap4.style.gridTemplateColumns = '1fr 1fr 1fr';
        wrap4.style.gap = '20px';
        wrap4.style.marginBottom = '15px';

        wrap1.appendChild(nameInput);
        wrap1.appendChild(companyInput);

        wrap2.appendChild(address1Input);
        wrap2.appendChild(address2Input);

        wrap3.appendChild(cityInput);
        wrap3.appendChild(stateInput);      

        wrap4.appendChild(zipInput);
        wrap4.appendChild(phoneInput);       
        otherPeopleRow.appendChild(wrap1);      
        otherPeopleRow.appendChild(wrap2);
        otherPeopleRow.appendChild(wrap3);
        otherPeopleRow.appendChild(wrap4);
        otherPeopleRow.appendChild(involvementDropdown);

        return otherPeopleRow;
    }  
    function buildOtherPeopleInvolvedSection() {
        var sectionContainer = document.createElement('div');
        sectionContainer.style.marginTop = '-10px';

        var heading = document.createElement('h3');
        heading.textContent = 'Other People Involved';
        heading.style.fontSize = '18px';
        heading.style.fontWeight = 'bold';
        heading.style.marginBottom = '15px';
        sectionContainer.appendChild(heading);

        // Table with all fields
        otherPeopleTable = table.build({
            tableId: 'otherPeopleInvolvedTable',
            columnHeadings: ['Other Person', 'Involvement'],
            endIcon: true
        });
        otherPeopleTable.style.marginBottom = '15px';
        sectionContainer.appendChild(otherPeopleTable);

        // Populate existing data
        if (!otherPeopleInvolvedData) { otherPeopleInvolvedData = []; }
        if (reviewData && reviewData.itOthersInvolved && reviewData.itOthersInvolved.length > 0) {
            otherPeopleInvolvedData = reviewData.itOthersInvolved.map(e => ({
                otherPersonId: e.othersInvolvedId,
                name: e.name,
                company: e.company,
                involvementTypeId: e.involvementTypeId,
                involvementTypeDescription: e.involvementDescription,
                address1: e.address1,
                address2: e.address2,
                city: e.city,
                state: e.state,
                zipCode: e.zipcode,
                phone: e.phone
            }));
        }
        populateOtherPeopleTable(); 

        // ADD BUTTON
        var addBtnWrap = document.createElement('div');
        addBtnWrap.style.display = 'flex';
        addBtnWrap.style.justifyContent = 'flex-end';
        addBtnWrap.style.marginBottom = '15px';
        addBtnWrap.style.textAlign = 'right';
        function validateForm() {

            let nameInputVal = nameInput.input.value;
            let zipInputVal = zipInput.input.value;
            let phoneInputVal = phoneInput.input.value;
            let involvementVal = involvementDropdown.select.value;

            if (nameInputVal === '') {
                nameInput.input.classList.add('error');
            }
            else {
                const isSpaceOnly = str => /^ *$/.test(str);
                if (isSpaceOnly(nameInputVal)) {
                    nameInput.input.classList.add('error');
                }
                else {
                    nameInput.input.classList.remove('error');
                }
            }

            if (involvementVal === '') {
                involvementDropdown.select.classList.add('error');
            }
            else {
                involvementDropdown.select.classList.remove('error');
            }

            const zipCodeRegex = /^\d{5}(-\d{4})?$/;
            if (zipInputVal !== '' && !zipCodeRegex.test(zipInputVal)) {
                zipInput.input.classList.add('error');
            }
            else {
                zipInput.input.classList.remove('error');
            }

            const phoneRegex = /^(?:\+1)?[\s.-]?\(?([0-9]{3})\)?[\s.-]?([0-9]{3})[\s.-]?([0-9]{4})$/;
            if (phoneInputVal !== '' && !phoneRegex.test(phoneInputVal)) {
                phoneInput.input.classList.add('error')
            }
            else {
                phoneInput.input.classList.remove('error')
            }

            var hasErrors = otherPersonFormSection.querySelectorAll('.error:not(button)');
            if (hasErrors.length === 0) {
                if (!isreadOnly()) {
                    saveBtn.classList.remove('disabled');
                }    
               
            } else {
                saveBtn.classList.add('disabled');
            }
            checkRequiredFields(hasErrors.length > 0);
        }
        function showDeleteWarning(id) {
            var deleteWarningPopup = POPUP.build({});
            var message = document.createElement('p');
            message.innerHTML = 'Are you sure you want to remove this record?';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var yesBtn = button.build({
                text: 'Yes',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    // Remove from data array
                    otherPeopleInvolvedData = otherPeopleInvolvedData.filter(d => d.otherPersonId !== id);
                    populateOtherPeopleTable();
                    POPUP.hide(deleteWarningPopup);
                }
            });
            var noBtn = button.build({
                text: 'No',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(deleteWarningPopup);
                }
            });
            btnWrap.appendChild(yesBtn);
            btnWrap.appendChild(noBtn);
            deleteWarningPopup.appendChild(message);
            deleteWarningPopup.appendChild(btnWrap);
            POPUP.show(deleteWarningPopup);
        }
        var addBtn = button.build({
            text: 'ADD OTHER PERSON',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                otherPersonFormSection.removeAttribute('data-edit-row-id');

                // Clear all form fields
                validateForm();
                otherPersonFormSection.querySelectorAll('input').forEach(inp => inp.value = '');
                otherPersonFormSection.querySelectorAll('select').forEach(sel => sel.value = '');
                otherPersonFormSection.style.display =
                    otherPersonFormSection.style.display === 'none' ? 'block' : 'none';
                addBtn.classList.add('hidden');
            }
        });
        if (!isreadOnly()) {
            addBtnWrap.appendChild(addBtn);
        }       
        sectionContainer.appendChild(addBtnWrap);

        // Form (hidden by default)
        var otherPersonFormSection = document.createElement('div');
        otherPersonFormSection.id = 'otherPersonFormSection';
        otherPersonFormSection.style.display = 'none';
        otherPersonFormSection.style.padding = '20px';
        otherPersonFormSection.style.border = '1px solid #ddd';
        otherPersonFormSection.style.borderRadius = '4px';
        otherPersonFormSection.style.backgroundColor = '#f9f9f9';
        otherPersonFormSection.style.marginBottom = '30px';

        // Name and Company
        var grid1 = document.createElement('div');
        grid1.style.display = 'grid';
        grid1.style.gridTemplateColumns = '1fr 1fr';
        grid1.style.gap = '20px';
        grid1.style.marginBottom = '15px';

        var nameInput = new Input({ label: 'Name*', type: 'text', style: 'secondary', classNames: ['nameInput'], id:'otherPeopleNameInput', maxlength:50});
        var companyInput = new Input({ label: 'Company', type: 'text', style: 'secondary', classNames: ['companyInput'], id: 'otherPeopleCompanyInput' });
        nameInput.input.addEventListener('input', e => {
            validateForm();
        });
        companyInput.input.addEventListener('input', e => {
            validateForm();
        });
        grid1.appendChild(nameInput.rootElement);
        grid1.appendChild(companyInput.rootElement);
        otherPersonFormSection.appendChild(grid1);
       
        // Address fields
        var grid2 = document.createElement('div');
        grid2.style.display = 'grid';
        grid2.style.gridTemplateColumns = '1fr 1fr';
        grid2.style.gap = '20px';
        grid2.style.marginBottom = '15px';

        var address1Input = new Input({ label: 'Address 1', type: 'text', style: 'secondary', classNames: ['address1Input'], id: 'otherPeopleAddress1Input' });
        var address2Input = new Input({ label: 'Address 2', type: 'text', style: 'secondary', classNames: ['address2Input'], id: 'otherPeopleAddress2Input' });

        grid2.appendChild(address1Input.rootElement);
        grid2.appendChild(address2Input.rootElement);
        otherPersonFormSection.appendChild(grid2);

        // City, State
        var grid3 = document.createElement('div');
        grid3.style.display = 'grid';
        grid3.style.gridTemplateColumns = '1fr 1fr';
        grid3.style.gap = '20px';
        grid3.style.marginBottom = '15px';

        var cityInput = new Input({ label: 'City', type: 'text', style: 'secondary', classNames: ['cityInput'], id: 'otherPeopleCityInput' });
        var stateInput = new Input({ label: 'State', type: 'text', style: 'secondary', classNames: ['stateInput'], id: 'otherPeopleStateInput' });

        grid3.appendChild(cityInput.rootElement);
        grid3.appendChild(stateInput.rootElement);        
        otherPersonFormSection.appendChild(grid3);

        // zip, phone
        var grid4 = document.createElement('div');
        grid4.style.display = 'grid';
        grid4.style.gridTemplateColumns = '1fr 1fr';
        grid4.style.gap = '20px';
        grid4.style.marginBottom = '15px';

        var zipInput = new Input({ label: 'Zip', type: 'text', style: 'secondary', classNames: ['zipInput'], id: 'otherPeopleZipInput' });
        zipInput.input.addEventListener('input', e => { validateForm(); });
        var phoneInput = new Input({ label: 'Phone', type: 'tel', style: 'secondary', classNames: ['phoneInput'], id: 'otherPeoplePhoneInput' });
        phoneInput.input.addEventListener('input', e => { validateForm() });

        grid4.appendChild(zipInput.rootElement);
        grid4.appendChild(phoneInput.rootElement);
        otherPersonFormSection.appendChild(grid4);
        // Involvement
        var involvementTypes = incidentTracking.getInvolvementTypes();
        var invData = involvementTypes.map(it => ({
            value: it.involvementId === '%' ? '' : it.involvementId,
            text: it.description
        }));
        invData.unshift({ value: '', text: '' });
        var involvementDropdown = new Select({
            data: invData,
            id: 'otherPeopleInvolvementInput',
            label: 'Involvement*', style: 'secondary', className: 'involvementDropdown',           
        });
        involvementDropdown.select.addEventListener('change', e => { validateForm() });
        otherPersonFormSection.appendChild(involvementDropdown.rootElement);
        // Save / Cancel buttons
        var btnWrap = document.createElement('div');
        btnWrap.style.display = 'flex';
        btnWrap.style.gap = '10px';
        btnWrap.style.justifyContent = 'flex-end';

        var saveBtn = button.build({
            text: 'SAVE',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                var nameVal = nameInput.input.value.trim();
                var companyVal = companyInput.input.value.trim();
                var involvementId = involvementDropdown.select.value;
                var involvementText = involvementDropdown.select.options[
                    involvementDropdown.select.selectedIndex
                ].text;
                var address1Val = address1Input.input.value.trim();
                var address2Val = address2Input.input.value.trim();
                var cityVal = cityInput.input.value.trim();
                var stateVal = stateInput.input.value.trim();
                var zipVal = zipInput.input.value.trim();
                var phoneVal = phoneInput.input.value.trim();

                var editId = otherPersonFormSection.getAttribute('data-edit-row-id');
                if (editId) {
                    var dataIndex = otherPeopleInvolvedData.findIndex(d => d.otherPersonId === editId);
                    if (dataIndex !== -1) {
                        otherPeopleInvolvedData[dataIndex] = {
                            otherPersonId: editId,
                            name: nameVal,
                            company: companyVal,
                            involvementTypeId: involvementId,
                            involvementTypeDescription: involvementText,
                            address1: address1Val,
                            address2: address2Val,
                            city: cityVal,
                            state: stateVal,
                            zipCode: zipVal,
                            phone: phoneVal
                        };
                    }

                }
                else {
                    if (!otherPeopleInvolvedData) otherPeopleInvolvedData = [];
                    otherPeopleInvolvedData.push({
                        otherPersonId: 'temp_' + Date.now(),
                        name: nameVal,
                        company: companyVal,
                        involvementTypeId: involvementId,
                        involvementTypeDescription: involvementText,
                        address1: address1Val,
                        address2: address2Val,
                        city: cityVal,
                        state: stateVal,
                        zipCode: zipVal,
                        phone: phoneVal
                    });
                }
                populateOtherPeopleTable();
                // Clear and hide form
                otherPersonFormSection.querySelectorAll('input').forEach(inp => inp.value = '');
                involvementDropdown.select.value = '';
                otherPersonFormSection.style.display = 'none';
                addBtn.classList.remove('hidden');
                checkRequiredFields(false);
            }
        });
       
        var cancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: () => {
                otherPersonFormSection.querySelectorAll('input').forEach(inp => inp.value = '');
                involvementDropdown.select.value = '';
                involvementDropdown.select.classList.remove('error');
                nameInput.input.classList.remove('error');
                otherPersonFormSection.querySelectorAll('input').forEach(inp => inp.parentElement.classList.remove('error'));
                otherPersonFormSection.removeAttribute('data-edit-row-id');
                otherPersonFormSection.style.display = 'none';
                addBtn.classList.remove('hidden');
                checkRequiredFields(false);
            }
        });

        if (!isreadOnly()) {
            btnWrap.appendChild(saveBtn);
        }
      
        btnWrap.appendChild(cancelBtn);
        otherPersonFormSection.appendChild(btnWrap);
        sectionContainer.appendChild(otherPersonFormSection);

        // Edit & Delete handling
        otherPeopleTable.addEventListener('click', e => {
            if (e.target.classList.contains('endIcon') && $.session.incidentTrackingDelete) {
                var row = e.target.closest('.table__row');
                let rowId = row.dataset.id;

                showDeleteWarning(rowId);
                return;
            }
            if (e.target.parentElement.classList.contains('header')) return;
            if (!e.target.classList.contains('table__row')) return;
            // Edit – populate form with all fields
            if (!e.target.classList.contains('endIcon')) {
                var row = e.target.closest('.table__row');              
                nameInput.input.value = row.dataset.name || '';
                companyInput.input.value = row.dataset.company || '';
                involvementDropdown.select.value = row.dataset.involvementId || '';
                address1Input.input.value = row.dataset.address1 || '';
                address2Input.input.value = row.dataset.address2 || '';
                cityInput.input.value = row.dataset.city || '';
                stateInput.input.value = row.dataset.state || '';
                zipInput.input.value = row.dataset.zip || '';
                phoneInput.input.value = row.dataset.phone || '';

                otherPersonFormSection.setAttribute('data-edit-row-id', row.dataset.id);
                otherPersonFormSection.style.display = 'block';
                addBtn.classList.add('hidden');
                validateForm();               
            }
        });

        return sectionContainer;
    }
    function populateOtherPeopleTable() {
        var tbody = otherPeopleTable.querySelector('.table__body') || otherPeopleTable.querySelector('tbody');
        tbody.innerHTML = '';
        otherPeopleInvolvedData = otherPeopleInvolvedData.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
        otherPeopleInvolvedData.forEach(person => {
            var tr = document.createElement('div');
            tr.classList.add('table__row', 'disabledRow');
            tr.dataset.id = person.otherPersonId || 'temp_' + Date.now();
            tr.setAttribute('data-name', person.name || '');
            tr.setAttribute('data-company', person.company || '');
            tr.setAttribute('data-involvement-id', person.involvementTypeId || '');
            tr.setAttribute('data-involvement-text', person.involvementTypeDescription || '');
            tr.setAttribute('data-address1', person.address1 || '');
            tr.setAttribute('data-address2', person.address2 || '');
            tr.setAttribute('data-city', person.city || '');
            tr.setAttribute('data-state', person.state || '');
            tr.setAttribute('data-zip', person.zipCode || '');
            tr.setAttribute('data-phone', person.phone || '');

            tr.innerHTML = `
                <div>${person.name || ''}</div>
                <div>${person.involvementTypeDescription || ''}</div>                
                `;
            if ($.session.incidentTrackingDelete) {
                tr.innerHTML += `<div class="endIcon" style="text-align: right; width: 50px;">${icons['delete']}</div>`;
            }
            else {
                tr.innerHTML += '<div></div>';
            }
            tbody.appendChild(tr);
        });
    }
    function buildAttachmentSection() {
        var description = '', filePath = '';
        var sectionContainer = document.createElement('div');
        sectionContainer.style.marginTop = '-10px';

        var attachmentFormSection = document.createElement('div');
        attachmentFormSection.id = 'attachmentFormSection';
        attachmentFormSection.style.display = 'none';
        attachmentFormSection.style.marginBottom = '30px';
        attachmentFormSection.style.padding = '20px';
        attachmentFormSection.style.border = '1px solid #ddd';
        attachmentFormSection.style.borderRadius = '4px';
        attachmentFormSection.style.backgroundColor = '#f9f9f9';

        var heading = document.createElement('h3');
        heading.textContent = 'Attachments';
        heading.style.fontSize = '18px';
        heading.style.fontWeight = 'bold';
        heading.style.marginBottom = '15px';
        sectionContainer.appendChild(heading);

        // Table with all fields
        attchamentsTable = table.build({
            tableId: 'attchamentsTable',
            columnHeadings: ['Description'],
            endIcon: true
        });
        attchamentsTable.style.marginBottom = '15px';
        sectionContainer.appendChild(attchamentsTable);

        // ADD BUTTON
        var addBtnWrap = document.createElement('div');
        addBtnWrap.style.display = 'flex';
        addBtnWrap.style.justifyContent = 'flex-end';
        addBtnWrap.style.marginBottom = '15px';
        addBtnWrap.style.textAlign = 'right';
        var addBtn = button.build({
            text: 'ADD ATTACHMENT',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                attachmentFormSection.style.display = 'block';
                addBtn.classList.add('hidden');
                validateForm();                
            }
        });
        if (!isreadOnly()) {
            addBtnWrap.appendChild(addBtn);
        }       
        sectionContainer.appendChild(addBtnWrap);
     
        // Name and Company
        var grid1 = document.createElement('div');
        grid1.style.display = 'grid';
        grid1.style.gridTemplateColumns = '1fr 1fr';
        grid1.style.gap = '20px';
        grid1.style.marginBottom = '15px';        
        const fileInput = new Input({ label: 'File Path*', id: 'fileInput', type:'file' });       
        var descInput = new Input({ label: 'Description*', id: 'descInput' });
        descInput.input.style.height = '46px';
        grid1.appendChild(fileInput.rootElement);        
        grid1.appendChild(descInput.rootElement);
        attachmentFormSection.appendChild(grid1);
        // Save / Cancel buttons
        var btnWrap = document.createElement('div');
        btnWrap.style.display = 'flex';
        btnWrap.style.gap = '10px';
        btnWrap.style.justifyContent = 'flex-end';

        var saveBtn = button.build({
            text: 'SAVE',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                var editId = attachmentFormSection.getAttribute('data-edit-row-id');
                if (editId) {
                    var dataIndex = attchmentsData.findIndex(d => d.attachmentId === editId);
                    if (dataIndex !== -1) {
                    }      
                }
                else {
                    const attPromise = new Promise(resolve => {
                        const file = fileInput.input;
                        const attachmentFile = file.files.item(0);                      
                        const attachmentType = attachmentFile.name.split('.').pop();
                        attchmentsData.push({
                            attachmentId: 'tmp_' + Date.now(),
                            description: description,
                            type: attachmentType,
                            arrayBuffer: null
                        });
                        new Response(attachmentFile).arrayBuffer().then(res => {
                            attchmentsData[attchmentsData.length - 1].arrayBuffer = res;                           
                            resolve();
                        });
                    });
                }
                Promise.all(attchmentsData).then(res => {
                    populateAttachments();
                });
                // Clear and hide form
                filePath = '';
                description = '';
                attachmentFormSection.querySelectorAll('input').forEach(inp => inp.value = '');              
                attachmentFormSection.style.display = 'none';
                addBtn.classList.remove('hidden');

            }
        });
       
        var cancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: () => {
                attachmentFormSection.querySelectorAll('input').forEach(inp => inp.value = '');
                attachmentFormSection.style.display = 'none';
                addBtn.classList.remove('hidden');
                filePath = '';
                description = '';
                fileInputEle.classList.remove('error');
                descInput.input.classList.remove('error');
                checkRequiredFields(false);
            }
        });

        if (!isreadOnly()) {
            btnWrap.appendChild(saveBtn);
        }
       
        btnWrap.appendChild(cancelBtn);
        attachmentFormSection.appendChild(btnWrap);
        sectionContainer.appendChild(attachmentFormSection);

        // Populate existing data
        if (!attchmentsData) { attchmentsData = []; }
        if (reviewData.itReviewData && reviewData.itReviewData.length > 0) {
            var itAttachmentList = reviewData.itReviewData[0].itAttachmentList || [];
            if (itAttachmentList && itAttachmentList.length > 0) {
                attchmentsData = itAttachmentList.map(e => ({
                    attachmentId: e.attachmentId,
                    description: e.description,
                }));
            }
        }
        populateAttachments();
        var fileInputEle = fileInput.input;
        fileInputEle.classList.add('nameInput');
        descInput.input.classList.add('companyInput');
        fileInputEle.addEventListener('input', e => {            
            let isValid = fileValidation(e.target);
            if (isValid) {
                filePath = e.target.value;
                description = e.target.files[0].name;
            }
            else {
                filePath = '';
                description = '';
            }
            descInput.setValue(description);
            validateForm();
        });
        fileInputEle.addEventListener("keydown", function (e) {
            e.preventDefault();
        });
        descInput.input.addEventListener('input', e => {
            description = e.target.value;           
            validateForm();
        });
        function validateForm() {
            if (filePath === '') {
                fileInputEle.classList.add('error');
            }
            else {
                fileInputEle.classList.remove('error');
            }
            if (description === '') {
                descInput.input.classList.add('error');
            }
            else{
                const isSpaceOnly = str => /^ *$/.test(str);
                if (isSpaceOnly(description)) {
                    descInput.input.classList.add('error');
                }
                else {
                    descInput.input.classList.remove('error');
                }               
            }           

            var hasErrors = attachmentFormSection.querySelectorAll('.error:not(button)');
            if (hasErrors.length === 0) {
                saveBtn.classList.remove('disabled');
            } else {
                saveBtn.classList.add('disabled');
            }
            checkRequiredFields(hasErrors.length > 0);
        }
        function fileValidation(target) {
            const fileType = target.files[0].type;
            const reFileTypeTest = new RegExp('(audio/)|(video/)');
            if (reFileTypeTest.test(fileType)) {
                failSave.show('Anywhere currently does not accept audio or video files');
                setTimeout(() => { failSave.hide(); }, 3000);
                target.value = '';
                return false;
            }
            const fileSize = target.files[0].size;
            const maxSize = 5 * 1024 * 1024; // 5 MB

            //check uploaded file size. If greater than 5MB, alert and clear input
            if (fileSize > maxSize) {
                failSave.show('The file size must be 5MB or smaller.  Please add a smaller file.');     
                setTimeout(() => { failSave.hide(); }, 3000);
                target.value = '';
                return false;
            }
            return true;
        }
        function showDeleteWarning(id) {
            var deleteWarningPopup = POPUP.build({});
            var message = document.createElement('p');
            message.innerHTML = 'Are you sure you want to remove this record?';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var yesBtn = button.build({
                text: 'Yes',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    // Remove from data array
                    attchmentsData = attchmentsData.filter(d => d.attachmentId !== id);
                    attachmentsToDelete.push(id);
                    populateAttachments();
                    POPUP.hide(deleteWarningPopup);
                }
            });
            var noBtn = button.build({
                text: 'No',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(deleteWarningPopup);
                }
            });
            btnWrap.appendChild(yesBtn);
            btnWrap.appendChild(noBtn);
            deleteWarningPopup.appendChild(message);
            deleteWarningPopup.appendChild(btnWrap);
            POPUP.show(deleteWarningPopup);
        }

        attchamentsTable.addEventListener('click', e => {
            if (e.target.classList.contains('endIcon') && $.session.incidentTrackingDelete) {
                var row = e.target.closest('.table__row');
                let rowId = row.dataset.id;
                showDeleteWarning(rowId);
                return;
            }
            if (e.target.parentElement.classList.contains('header')) return;
            if (!e.target.classList.contains('table__row')) return;
           
            if (!e.target.classList.contains('endIcon')) {
                var row = e.target.closest('.table__row');
                if (row.dataset.id.indexOf('tmp') < 0) {
                    incidentTrackingAjax.viewIncidentTrackingAttachment(row.dataset.id);
                }
                else {
                    var attachment = attchmentsData.filter(d => d.attachmentId === row.dataset.id);
                    var fileType;                   
                    const ext = attachment[0].type;
                    fileType = UTIL.MIMEType(ext);  
                   
                    const blob = new Blob([attachment[0].arrayBuffer], { type: fileType || "application/octet-stream" });
                    if ($.session.browser == 'Explorer' || $.session.browser == 'Mozilla') {
                        window.navigator.msSaveOrOpenBlob(blob, 'report.pdf');
                    } else {
                        var fileURL = URL.createObjectURL(blob);
                        window.open(fileURL);
                    }
                }
            }
        });
        return sectionContainer;
    }
    function populateAttachments() {
        console.log(attchmentsData)
        var tbody = attchamentsTable.querySelector('.table__body') || attchamentsTable.querySelector('tbody');
        tbody.innerHTML = '';     
        attchmentsData.forEach(a => {
            var tr = document.createElement('div');
            tr.classList.add('table__row', 'disabledRow');
            tr.dataset.id = a.attachmentId || 'temp_' + Date.now();
            tr.setAttribute('data-description', a.description || '');           

            tr.innerHTML = `<div>${a.description || ''}</div> `;             
            if ($.session.incidentTrackingDelete) {
                tr.innerHTML += `<div class="endIcon" style="text-align: right; width: 50px;">${icons['delete']}</div>`;
            }
            else {
                tr.innerHTML += '<div></div>';
            }
            tbody.appendChild(tr);
        });
    }

    async function saveAttachments(incidentId) {
        let attachments = attchmentsData
        const saveAttachmentPromArray = [];
        attachments.forEach(attachment => {
            if (attachment.attachmentId.indexOf('tmp') >= 0) {
                const promise = new Promise((resolve, reject) => {
                    incidentTrackingAjax.addIncidentTrackingAttachment(
                        incidentId,
                        attachment.description,
                        attachment.type,
                        attachment.arrayBuffer,
                        res => {

                        },
                    );

                });
                saveAttachmentPromArray.push(promise);
            }
        });
        attachmentsToDelete.forEach(id => {
            if (id.indexOf('tmp') < 0) {
                const promise = new Promise((resolve, reject) => {
                    incidentTrackingAjax.deleteIncidentTrackingAttachment(incidentId, id);
                });
                saveAttachmentPromArray.push(promise);
            }
        });
        Promise.all(saveAttachmentPromArray).then(() => {
            return true;
        });    
    }


    async function buildIncidentDetailsContent() {
        var mainContainer = document.createElement('div');
        mainContainer.classList.add('incidentSection');
        mainContainer.style.padding = '20px';       

        // Heading
        var heading = document.createElement('h3');
        heading.textContent = 'Incident Details';
        heading.style.marginBottom = '30px';
        heading.style.fontSize = '24px';
        mainContainer.appendChild(heading);
       
        await setSectionValues();

        var dateTimeInputs = buildDateTimeInputs();
        var dropdowns = buildDropdowns();
        var textAreas = buildTextAreas();
        
        // Attachments button
       

        // Append all elements
        mainContainer.appendChild(dateTimeInputs);
        mainContainer.appendChild(dropdowns);
        const separator = document.createElement('div');
        separator.style.height = '5px';
        mainContainer.appendChild(separator);
        mainContainer.appendChild(textAreas);
       
        // Append Individuals/Employees/Other People sections
        mainContainer.appendChild(buildIndividualsInvolvedSection());
        mainContainer.appendChild(buildEmployeesInvolvedSection());
        mainContainer.appendChild(buildOtherPeopleInvolvedSection());
        mainContainer.appendChild(buildAttachmentSection());

        // Save and Cancel buttons
        var buttonWrap = document.createElement('div');
        buttonWrap.classList.add('btnWrap');
        buttonWrap.style.display = 'flex';
        buttonWrap.style.gap = '15px';
        buttonWrap.style.justifyContent = 'flex-end';
        buttonWrap.style.marginTop = '10px';
        buttonWrap.style.paddingTop = '20px';
        buttonWrap.style.borderTop = '1px solid #e0e0e0';

        var saveBtn = button.build({
            text: 'SAVE',
            classNames: 'saveIncident',
            type: 'contained',
            style: 'secondary',
            callback: function () {
                showProgressPopup('Saving Incident Details...');
                saveIncidentDetails();
            }
        });
        buttonWrap.appendChild(saveBtn);
        if (isreadOnly()) {
            saveBtn.classList.add('disabled');
        }
        if ((SelectedIncidentId || '0') > 0  && $.session.incidentTrackingDelete) {
            var deleteBtn = button.build({
                text: 'Delete',
                classNames: 'deleteIncident',
                type: 'contained',
                style: 'secondary',
                callback: function () {
                    showIncidentDeleteWarning();
                }
            });
            buttonWrap.appendChild(deleteBtn);
        }
        var cancelBtn = button.build({
            text: 'CANCEL',
            type: 'outlined',
            style: 'secondary',
            callback: function () {
                incidentOverview.init(SelectedConsumer)
            }
        });
        buttonWrap.appendChild(cancelBtn);

        mainContainer.appendChild(buttonWrap);

        setupIncidentDetailsEvents();       
        return mainContainer;
    }
    function showIncidentDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this incident?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                incidentTrackingAjax.deleteITIncident(SelectedIncidentId);
                POPUP.hide(deleteWarningPopup);
                incidentOverview.init(SelectedConsumer);
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function setupIncidentDetailsEvents() {
        if (incidentDateInput) {
            incidentDateInput.input.addEventListener('change', e => {
                incidentDate = e.target.value;
                checkRequiredFields(false);
            });
        }

        if (incidentTimeInput) {
            incidentTimeInput.input.addEventListener('change', e => {
                incidentTime = e.target.value;
            });
        }

        if (reportedDateInput) {
            reportedDateInput.input.addEventListener('change', e => {
                reportedDate = e.target.value;
            });
        }

        if (reportedTimeInput) {
            reportedTimeInput.input.addEventListener('change', e => {
                reportedTime = e.target.value;
            });
        }

        if (summaryTextarea) {
            summaryTextarea.setValue(summaryText);
            summaryTextarea.input.addEventListener('change', e => {
                summaryText = e.target.value;                
            });
        }

        if (actionTextarea) {
            actionTextarea.setValue(actionText);
            actionTextarea.input.addEventListener('change', e => {
                actionText = e.target.value;
            });
        }

        if (preventionTextarea) {
            preventionTextarea.setValue(preventionText);
            preventionTextarea.input.addEventListener('change', e => {
                preventionText = e.target.value;
            });
        }

        if (causeTextarea) {
            causeTextarea.setValue(factorsText);
            causeTextarea.input.addEventListener('change', e => {
                factorsText = e.target.value;
            });
        }
        const fullScreenTextarea = document.querySelector('textarea.fullscreen');
        fullScreenTextarea.addEventListener('change', e => {          
            const event = new CustomEvent('change', {
                bubbles: true,
                cancelable: true,
                detail: true,
            });
            summaryTextarea.input.dispatchEvent(event);
            actionTextarea.input.dispatchEvent(event);
            preventionTextarea.input.dispatchEvent(event);
            causeTextarea.input.dispatchEvent(event);
        });
        
        if (categoryDropdown) {
            categoryDropdown.select.addEventListener('change', e => {
                categoryId = e.target.value;
            });
        }

        if (locationDetailDropdown) {
            locationDetailDropdown.select.addEventListener('change', e => {
                locationId = e.target.value;
            });
        }
    }

    function checkRequiredFields(hasErrors = false) {        
        var saveBtn = document.querySelector('button.saveIncident');
        var errorIcon = document.getElementById('errorIcon');
        if (incidentDateInput) {           
            if ((incidentDate || '') === '') {
                incidentDateInput.input.classList.add('error');
               
            } else {
                incidentDateInput.input.classList.remove('error');
            }
        }

        var detailsHasErrors = incidentDetailsSection
            ? [].slice.call(incidentDetailsSection.querySelectorAll('.error'))
            : [];
        if (saveBtn && errorIcon) {
            if (hasErrors || detailsHasErrors.length > 0 || individualsInvolvedData.length == 0) {

                saveBtn.classList.add('disabled');
                errorIcon.classList.remove('hidden')
            }
            else {
                if (!isreadOnly()) {
                    saveBtn.classList.remove('disabled')
                }
                errorIcon.classList.add('hidden')
            }
        }
        isErrorOccured = (hasErrors || detailsHasErrors.length > 0);
        return isErrorOccured;
    }

    function saveIncidentDetails() {     

        // Get values from inputs
        var iDateInput = incidentDateInput.input;
        var iTimeInput = incidentTimeInput.input;
        var rDateInput = reportedDateInput.input;
        var rTimeInput = reportedTimeInput.input;
        var summaryTA = summaryTextarea.input;
        var actionTA = actionTextarea.input;
        var preventionTA = preventionTextarea ? preventionTextarea.input : null;
        var causeTA = causeTextarea ? causeTextarea.input : null;
        var categorySelect = categoryDropdown.select;
        var locationSelect = locationDetailDropdown.select;

        // Collect Individuals Involved data from TABLE       
        var consumerIds = [];
        var consumerInvolvementIds = [];
        var consumerLocationIds = [];
        var consumerIncludeCounts = [];
        var consumerInvolvedIds = [];

        individualsInvolvedData.forEach(c => {

            // Only include real IDs (not temporary ones)
            if (!c.consumerInvolvedId.startsWith('temp_')) {
                consumerInvolvedIds.push(c.consumerInvolvedId);
            } else {
                consumerInvolvedIds.push('0');
            }

            consumerIds.push(c.consumerId);
            consumerInvolvementIds.push(c.involvementTypeId);
            consumerLocationIds.push(c.locationId);
            consumerIncludeCounts.push(c.includeInCount === 'Y' ? 'Y' : 'N');
        });

        // Collect Employees Involved data from TABLE      
        var employeeIds = [];
        var employeeInvolvementIds = [];
        var notifyEmployees = [];

        employeesInvolvedData.forEach(row => {
            var employeeId = row.employeeId
            var involvementId = row.employeeInvolvementTypeId
            var notify = row.notifyEmployee;

            employeeIds.push(employeeId);
            employeeInvolvementIds.push(involvementId);
            notifyEmployees.push(notify);
        });

        // Collect Other People Involved data from TABLE      
        var names = [];
        var companies = [];
        var addresses1 = [];
        var addresses2 = [];
        var cities = [];
        var states = [];
        var zips = [];
        var phones = [];
        var involvementTypes = [];

        otherPeopleInvolvedData.forEach(row => {
            names.push(UTIL.removeUnsavableNoteText(row.name));
            companies.push(UTIL.removeUnsavableNoteText(row.company || ''));
            addresses1.push(UTIL.removeUnsavableNoteText(row.address1 || ''));
            addresses2.push(UTIL.removeUnsavableNoteText(row.address2 || ''));
            cities.push(UTIL.removeUnsavableNoteText(row.city || ''));
            states.push(row.state || '');
            zips.push(row.zipCode || '');
            phones.push(row.phone || '');
            involvementTypes.push(row.involvementTypeId || '');
        });

        // Build save data object matching the backend structure
        var saveData = {
            token: $.session.Token,
            updateIncidentId: SelectedIncidentId || '0',
            saveUpdate: SelectedIncidentId ? 'Update' : 'Save',

            // Incident Details
            incidentDate: iDateInput ? iDateInput.value : '',
            incidentTime: iTimeInput ? iTimeInput.value : '',
            reportedDate: rDateInput ? rDateInput.value : '',
            reportedTime: rTimeInput ? rTimeInput.value : '',
            subcategoryId: categorySelect ? categorySelect.value : '',
            locationDetailId: locationSelect ? locationSelect.value : '',
            summary: summaryTA ? UTIL.removeUnsavableNoteText(summaryTA.value) : '',
            note: actionTA ? UTIL.removeUnsavableNoteText(actionTA.value) : '',
            prevention: preventionTA ? UTIL.removeUnsavableNoteText(preventionTA.value) : '',
            contributingFactor: causeTA ? UTIL.removeUnsavableNoteText(causeTA.value) : '',

            // Employees Involved (pipe-delimited)
            employeeIdString: employeeIds.join('|'),
            employeeInvolvementIdString: employeeInvolvementIds.join('|'),
            notifyEmployeeString: notifyEmployees.join('|'),

            // Other People Involved (pipe-delimited)
            othersInvolvedNameString: names.join('|'),
            othersInvolvedCompanyString: companies.join('|'),
            othersInvolvedAddress1String: addresses1.join('|'),
            othersInvolvedAddress2String: addresses2.join('|'),
            othersInvolvedCityString: cities.join('|'),
            othersInvolvedStateString: states.join('|'),
            othersInvolvedZipCodeString: zips.join('|'),
            othersInvolvedPhoneString: phones.join('|'),
            othersInvolvedInvolvementTypeIdString: involvementTypes.join('|'),

            // Consumers Involved (pipe-delimited)
            consumerIdString: consumerIds.join('|'),
            involvementId: consumerInvolvementIds.join('|'),
            consumerIncidentLocationIdString: consumerLocationIds.join('|'),
            includeInCount: consumerIncludeCounts.join('|'),
            consumerInvolvedIdString: consumerInvolvedIds.join('|'),

            // Optional fields
            incidentTypeId: null,
            incidentTypeDesc: null,
            serviceLocationId: null,
            othersInvolvedInvolvementDescriptionString: null
        };

        try {
            // Call the save API
            incidentTrackingAjax.saveUpdateITIncident(saveData, function (response) {
                if (response === 'Bad Request') {
                    hideProgressPopup();
                    failSave.show('An error occured');
                    console.log(response);
                    setTimeout(() => { failSave.hide(); }, 3000);
                }
                else {
                    if (response && response.length > 0) {                      
                        SelectedIncidentId = response[0].split('|')[2];
                        saveAttachments(SelectedIncidentId).then(() => {
                            if (consumerId > 0) {
                                // Navigate to consumer details section      
                                if (response && response.length > 0) {
                                    incidentTrackingAjax.getIncidentEditReviewDataAllObjects(SelectedIncidentId, results => {
                                        consumerDetails.setGlobalVariables(SelectedIncidentId, consumerId, results.itConsumerInvolved, SelectedConsumer, newIncident);
                                        consumerDetails.init();
                                    });
                                }
                            }
                            else {
                                hideProgressPopup();
                                // Refresh the page to show updated data
                                incidentOverview.init(SelectedConsumer);
                            }
                        });
                    }
                }

            }, (consumerId || 0) === 0);
        }
        catch (error) {           
            hideProgressPopup();
            console.log(error);
            failSave.show('An error occured');
            setTimeout(() => { failSave.hide(); }, 3000);
        }
        
    }

    async function showIncidentDetails() {
        // Clear the content area
        if (contentDiv) contentDiv.innerHTML = '';

        // Remove active class from all individual nav links
        document.querySelectorAll("a.individual_nav.active").forEach(a => a.classList.remove("active"));

        // Add active class to Incident Details link
        var incidentDetailsLink = document.querySelector('a.incident_details_link');
        if (incidentDetailsLink) {
            incidentDetailsLink.classList.add('active');
        }

        // Build and show incident details content
        incidentDetailsSection = await buildIncidentDetailsContent();
        if (contentDiv) contentDiv.appendChild(incidentDetailsSection);
        if (reviewData?.itReviewData?.length > 0) {
            incidentPermissions.permissions(SelectedIncidentId, reviewData.itReviewData[0].originallyEnteredByUserId, { summary: summaryTextarea, action: actionTextarea, prevention: preventionTextarea, cause: causeTextarea }, newIncident);
        }
        checkRequiredFields();
    }
    //#endregion

    function buildSection() {
        var wrap = document.createElement('div');
        wrap.classList.add('leftMenuWrapper');

        // Left navigation
        var navElementWrapper = document.createElement('div');
        navElementWrapper.classList.add('leftSidebar');        
        var navEle = buildNavigation();
        navElementWrapper.appendChild(navEle);
        wrap.appendChild(navElementWrapper);

        // Content area
        contentDiv = document.createElement('div');
        contentDiv.classList.add('contentArea');       
        wrap.appendChild(contentDiv);

        return wrap;
    }

    function clearAllGlobalVariables() {       
        incidentDate = '';
        incidentTime = '';
        reportedDate = '';
        reportedTime = '';
        categoryId = '';
        locationId = '';
        summaryText = '';
        actionText = '';
        preventionText = '';
        factorsText = '';
        individualsInvolvedData = [];
        employeesInvolvedData = [];
        otherPeopleInvolvedData = [];
        attchmentsData = [];
        attachmentsToDelete = [];
    }

    function init(incidentId, consumer, data, isNewIncident) {
        newIncident = isNewIncident;       
        getSectionData();      

        SelectedIncidentId = incidentId;
        SelectedConsumer = consumer;
        reviewData = data;
        consumerId = 0;
       
        // CLEAR FIRST, before loading new data
        clearAllGlobalVariables();

        // Initialize data arrays AFTER clearing
        individualsInvolvedData = [];
        employeesInvolvedData = [];
        otherPeopleInvolvedData = [];

     
        // Load data from reviewData if it exists
        if (reviewData) {
            incidentLocations = reviewData.locations;
            if (reviewData.itConsumerInvolved) {
                individualsInvolvedData = reviewData.itConsumerInvolved;
            }
            if (reviewData.itEmployeeInvolved) {
                employeesInvolvedData = reviewData.itEmployeeInvolved;
            }
            if (reviewData.itOtherPeopleInvolved) {
                otherPeopleInvolvedData = reviewData.itOtherPeopleInvolved;
            }
        }

        DOM.clearActionCenter();
        showProgressPopup('Please wait while we gather everything up...');
        // Fetch all consumers FIRST, then build the UI
        fetchAllConsumers().then(() => {

            var detailCard = buildSection();
            DOM.ACTIONCENTER.appendChild(detailCard);            
            // Show incident details by default   
            showIncidentDetails();

            // Setup event delegation for navigation
            detailCard.addEventListener('click', function (event) {
                var target = event.target;

                if (target.classList.contains('individual_nav')) {
                    consumerId = 0;
                    if (!isErrorOccured) {
                        event.preventDefault();
                        handleIndividualNavEvents(event);
                    }
                    else {
                        failSave.show('Please fill all required fields.'); 
                        setTimeout(() => { failSave.hide(); }, 3000);
                    }
                }

                if (target.classList.contains('incident_details_link')) {
                    event.preventDefault();
                    showIncidentDetails();
                }
            });
          
            setTimeout(() => {            
                hideProgressPopup();
            }, 3000);
            
        }).catch(error => {
            hideProgressPopup();
            console.error('Error initializing incident details:', error);
            failSave.show('Error loading consumer data. Please refresh the page.');  
            setTimeout(() => { failSave.hide(); }, 3000);
        });       
    }
    function isreadOnly() {
        var isReadOnly = true;
        if ((SelectedIncidentId === 0 || newIncident === true) && $.session.incidentTrackingInsert === true) { isReadOnly = false; }
        if (SelectedIncidentId > 0 && $.session.incidentTrackingUpdate === true) { isReadOnly = false; }
        return isReadOnly;
    }
    function showProgressPopup(message) {
        pageLoadPopup = POPUP.build({
            hideX: true,
        });
        pageLoadPopup.style.minHeight = '40%';

        // magic to make overlay cover entire site for this once instance
        const overlayDiv = document.querySelector('div.overlay');
        const menuDiv = document.querySelector('div.module-menu');
        overlayDiv.style.zIndex = '100';
        menuDiv.style.zIndex = '99';

        const spinner = PROGRESS.SPINNER.get(message);
        spinner.style.display = 'block';
        pageLoadPopup.appendChild(spinner);
        POPUP.show(pageLoadPopup);      
    }
    function hideProgressPopup() {
        const overlayDiv = document.querySelector('div.overlay');
        const menuDiv = document.querySelector('div.module-menu');
        overlayDiv.style.zIndex = '30';
        menuDiv.style.zIndex = '100';
        POPUP.hide(pageLoadPopup);
    }
    return {
        init,
        checkRequiredFields,      
        clearAllGlobalVariables,
        showProgressPopup,
        hideProgressPopup
    };
})();